module.exports = __webpack_public_path__ + "img/2_wind.2b78c45d.jpg";